import React, { useState, useEffect } from 'react';
import { supabase } from '../../api/supabase';
import { useAuth } from '../../context/AuthContext';

const TYPES = [
  { key: 'package',       label: 'Package / Tour' },
  { key: 'ticket',        label: 'Airline Ticket' },
  { key: 'visa',          label: 'Visa' },
  { key: 'sale_quotation', label: 'Sale Quotation' },
  { key: 'quotation',     label: 'Pro Forma Invoice' },
];

export default function TermsAdmin() {
  const { user } = useAuth();
  const username = user?.email?.split('@')[0] || 'unknown';
  const [templates, setTemplates] = useState({});
  const [activeTab, setActiveTab] = useState('package');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('terms_templates').select('*').then(({ data }) => {
      const map = {};
      (data || []).forEach(t => { map[t.product_type] = t; });
      setTemplates(map);
      setLoading(false);
    });
  }, []);

  const current = templates[activeTab] || { content: '', title: '' };

  function setContent(val) {
    setTemplates(t => ({ ...t, [activeTab]: { ...current, content: val } }));
    setSaved(false);
  }

  async function handleSave() {
    setSaving(true);
    const { error } = await supabase.from('terms_templates')
      .upsert({
        product_type: activeTab,
        title: current.title,
        content: current.content,
        updated_by: username,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'product_type' });
    setSaving(false);
    if (!error) setSaved(true);
  }

  if (loading) return <div style={{ padding: 40, color: 'var(--text-muted)' }}>Loading…</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Terms &amp; Conditions</div>
          <div className="page-subtitle">Manage T&amp;C printed on quotations and invoices per product type</div>
        </div>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : saved ? 'Saved ✓' : 'Save Changes'}
        </button>
      </div>

      <div className="tabs" style={{ marginBottom: 0 }}>
        {TYPES.map(t => (
          <div key={t.key} className={`tab ${activeTab === t.key ? 'active' : ''}`}
            onClick={() => { setActiveTab(t.key); setSaved(false); }}>
            {t.label}
          </div>
        ))}
      </div>

      <div className="card" style={{ borderTopLeftRadius: 0, padding: 0 }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', fontSize: 12, color: 'var(--text-muted)' }}>
          This text prints on every <strong>{TYPES.find(t => t.key === activeTab)?.label}</strong>.
          Use numbered lists (1. 2. 3.) and section headings (1. Section Title). Last updated: {current.updated_at ? new Date(current.updated_at).toLocaleString() : '—'} by {current.updated_by || '—'}
        </div>
        <textarea
          value={current.content || ''}
          onChange={e => setContent(e.target.value)}
          style={{
            width: '100%', minHeight: 600, padding: 20,
            fontFamily: 'monospace', fontSize: 13, lineHeight: 1.7,
            border: 'none', outline: 'none', resize: 'vertical',
            background: 'var(--bg-input)', color: 'var(--text)',
            borderBottomLeftRadius: 10, borderBottomRightRadius: 10,
          }}
        />
      </div>
    </div>
  );
}
